import { useContext } from 'react';
import { DischargeContext } from '~/providers/DischargeProvider';
import { DischargeContextType } from '~/types/discharge';

export const useDischargeContext = (): DischargeContextType => {
  const ctx = useContext(DischargeContext);
  if (!ctx) {
    throw new Error('useDischargeContext must be used within DischargeProvider');
  }
  return ctx;
};
